const ITEMS = [
  "Behavioral Science",
  "Leadership",
  "Transformation",
  "Helping people create environments where everyone flourishes",
];

export default function Marquee() {
  const track = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee"
      className="border-y border-border bg-secondary/40 py-6 overflow-hidden"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap no-scrollbar">
        {track.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif text-2xl md:text-4xl font-light px-8 text-foreground/80">
              {item}
            </span>
            <span className="text-primary text-2xl md:text-4xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
